<template>
  <div>
    <div v-if="!isMobile" class="jc-page-content">
      <div class="jc-panel jc-panel-padding">
        <div
          class="jc-container-result jc-result-info"
          style="width: 600px; margin: 0 auto; padding: 100px 0px 150px 0px"
        >
          <div class="jc-box-icon">
            <i class="jc-icon-information" style="color: #2c68ff"></i>
          </div>

          <div class="jc-box-content">
            <h3>京东云合作伙伴：{{ distributorName }}</h3>

            <h3>邀请您成为他的客户</h3>

            <div class="jc-box-action">
              <el-button type="primary" @click="goTo('//login.jdcloud.com')"
                >我已有京东云账号，登录后再关联</el-button
              >

              <el-button
                type="primary"
                @click="goTo('//user.jdcloud.com/register')"
                >还没有账号，注册后再关联</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <InviteMobile v-else :distributorName="distributorName" />
  </div>
</template>

<script>
import { describeDistributor } from '@/api/distributor-api'
import InviteMobile from './InviteMobile.vue'
export default {
  components: {
    InviteMobile,
  },
  data() {
    return {
      isMobile: false,
      distributorName: '',
      distributorId: this.$route.params.id,
    }
  },
  created() {
    this.getData()
    this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
      navigator.userAgent,
    )
  },
  methods: {
    async getData() {
      const {
        result: {
          distributorResult: { distributorName },
        },
      } = await describeDistributor({
        distributorId: this.distributorId,
      })
      this.distributorName = distributorName
    },
    goTo(url) {
      let gotoUrl = `${url}?returnUrl=${encodeURIComponent(
        this.$route.query.returnUrl,
      )}`
      window.location.href = gotoUrl
    },
  },
}
</script>
